<template>
    <div>
        <b-row>
                <b-col cols="12">
                    <b-card class="d-flex justify-content-start">
                        <ValidationObserver ref="importForm">
                            <b-row>
                                <b-col cols="12">
                                    <ValidationProvider name="file" rules="required" v-slot="{ errors }">
                                        <b-form-group :label="$t('excel_file')">
                                            <div class="d-flex custom-file-upload">
                                                <b-form-file v-model="formData.file" :state="errors[0] ? false : null"
                                                             :placeholder="$t('select_file')" ref="fileInput"></b-form-file>
                                                <b-button variant="outline-secondary"
                                                          @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                                </b-button>
                                            </div>
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                        </ValidationObserver>
                    </b-card>
                </b-col>
                <b-col cols="12" class="mt-3 d-flex">
                    <b-button @click="save" variant="primary" class="btn-lg mr-2">{{ $t("save") }}</b-button>
                </b-col>
        </b-row>
    </div>
</template>
<script>
//Services
import ExamQuestionsService from "@/services/ExamQuestionsService"
//Components

//Other
import { ValidationObserver, ValidationProvider } from "vee-validate";

export  default {
    components: {
        ValidationObserver,
        ValidationObserver
    },

    props: {
        examExamId: {
            type: Number
        },
        courseId: {
            type: Number
        },
        updateData: {
            type: Object
        }
    },

    data() {
        return {
            formData: {},
        }
    },
    created() {

    },
    methods: {
        async save() {
            let isValid = await this.$refs.importForm.validate()
            if (isValid) {
                let formData = new FormData()
                formData.append("file", this.formData.file)
                ExamQuestionsService.uploadTemplate(formData, this.examExamId).then(response => {
                    this.$toast.success(this.$t('api.'+response.data.message))
                    this.$emit('successForm',true)
                }).catch(e => {
                    this.showErrors(e, null)
                })
            }
        }
    }
}
</script>
